<template>
    <bs5-base-modal title="Assign Distributor" :visible="visible" @close="closeModal">
        <template v-slot:default>
            <form @submit.prevent="assignDistributor">
                <div class="mb-3">
                    <bs5-base-label for="distributor">Select Distributor</bs5-base-label>
                    <select id="distributor" v-model="selectedDistributorId" class="form-select" v-if="distributors?.length > 0">
                        <option v-for="distributor in distributors" :key="distributor.id" :value="distributor.id">
                            {{ distributor.name }}
                        </option>
                    </select>
                    <span v-else>
                        No one distributor is available
                    </span>
                </div>
            </form>
        </template>

        <template v-slot:footer>
            <bs5-cancel-button @click="closeModal" />
            <bs5-save-button :loading="saving" @click="assignDistributor">Assign</bs5-save-button>
        </template>
    </bs5-base-modal>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from "vue";
import userService from "@/services/user.service";
import distributorService from "@/services/distributor.service";
import { Distributor } from "@/models/distributor.model";
import { showToast } from "@/utils/toast";

export default defineComponent({
    name: "AssignDistributorModal",
    props: {
        visible: { type: Boolean, required: true },
        userId: { type: String, required: true },
    },
    emits: ["close", "distributor-assigned"],
    data() {
        return {
            distributors: ref<Distributor[]>([]),
            selectedDistributorId: ref<string | null>(null),
            saving: ref(false),
        };
    },
    watch: {
        visible: {
            immediate: true,
            handler(newVal) {
                if (newVal) this.fetchDistributors();
            },
        },
    },
    methods: {
        async fetchDistributors() {
            try {
                const availableDistributors = await distributorService.getDistributors();
                const assignedDistibutor = await userService.getUserDistributor(this.userId);
                this.distributors = availableDistributors.filter(item => !assignedDistibutor.some(el => el.id === item.id));

            } catch (error) {
                console.error("Error fetching distributors:", error);
            }
        },
        async assignDistributor() {
            if (!this.selectedDistributorId) return;

            this.saving = true;
            try {
                await userService.assignDistributor(this.userId, this.selectedDistributorId);
                this.$emit("distributor-assigned");
                this.closeModal();
                showToast("Distributor assigned!", "success");
            } catch (error) {
                showToast("Failed to assign distributor!", "error");
            } finally {
                this.saving = false;
            }
        },
        closeModal() {
            this.$emit("close");
        },
    },
});
</script>